"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const react_1 = __importDefault(require("react"));
const usafacts_icon_gif_1 = __importDefault(require("./assets/usafacts-icon.gif"));
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
function LoadAnimation() {
  return react_1.default.createElement("div", {
    className: styles_module_css_1.default['loader-container']
  }, react_1.default.createElement("img", {
    src: usafacts_icon_gif_1.default,
    alt: "Loading..."
  }));
}
exports.default = LoadAnimation;